import { Link } from 'react-router-dom';
import { articles } from '@/mocks/homepage';

export default function ArticleSection() {
  return (
    <section className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-4 mb-12">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
              麻将攻略与技巧
            </h2>
            <p className="text-sm md:text-base text-foreground-500">
              从入门到精通，助你成为麻将高手
            </p>
          </div>
          <Link
            to="/article/majiang-rumen-jiaocheng"
            className="flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors cursor-pointer whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {articles.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group bg-background-50 rounded-xl border border-background-200/70 hover:border-primary-200/60 overflow-hidden transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-48 overflow-hidden">
                {article.imageSeq === 'article-1' && (
                  <img
                    src="https://readdy.ai/api/search-image?query=Warm%20toned%20Chinese%20style%20illustration%20with%20traditional%20mahjong%20tiles%20on%20dark%20wooden%20table%2C%20soft%20ambient%20lighting%2C%20elegant%20composition%2C%20minimalist%20aesthetic%2C%20calm%20atmosphere%2C%20refined%20color%20palette%2C%20subtle%20gold%20and%20burgundy%20accents%2C%20editorial%20photography%20style&width=800&height=400&seq=article-1&orientation=landscape"
                    alt={article.title}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                )}
                {article.imageSeq === 'article-2' && (
                  <img
                    src="https://readdy.ai/api/search-image?query=Closeup%20of%20traditional%20mahjong%20game%20in%20progress%2C%20warm%20lighting%2C%20wooden%20table%20surface%2C%20elegant%20Chinese%20aesthetic%2C%20golden%20accents%2C%20editorial%20style%20photography%2C%20shallow%20depth%20of%20field%2C%20cozy%20atmosphere&width=800&height=400&seq=article-2&orientation=landscape"
                    alt={article.title}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                )}
                {article.imageSeq === 'article-3' && (
                  <img
                    src="https://readdy.ai/api/search-image?query=Arranged%20mahjong%20tiles%20with%20Chinese%20tea%20set%20on%20wooden%20table%2C%20warm%20natural%20light%2C%20traditional%20Chinese%20decor%20in%20background%2C%20peaceful%20composition%2C%20soft%20shadows%2C%20cultural%20aesthetic%2C%20editorial%20photography&width=800&height=400&seq=article-3&orientation=landscape"
                    alt={article.title}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                )}
                {article.imageSeq === 'article-4' && (
                  <img
                    src="https://readdy.ai/api/search-image?query=Expert%20hands%20arranging%20mahjong%20tiles%20strategically%2C%20warm%20ambient%20lighting%2C%20polished%20wooden%20table%2C%20elegant%20atmosphere%2C%20professional%20game%20setting%2C%20rich%20colors%2C%20artistic%20composition%2C%20editorial%20photography%20style&width=800&height=400&seq=article-4&orientation=landscape"
                    alt={article.title}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                )}
                {article.imageSeq === 'article-5' && (
                  <img
                    src="https://readdy.ai/api/search-image?query=Mahjong%20game%20strategic%20moment%20with%20player%20contemplating%20moves%2C%20warm%20cozy%20room%20setting%2C%20soft%20lighting%2C%20traditional%20Chinese%20decor%2C%20intimate%20atmosphere%2C%20editorial%20quality%2C%20artistic%20photography&width=800&height=400&seq=article-5&orientation=landscape"
                    alt={article.title}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                )}
                {article.imageSeq === 'article-6' && (
                  <img
                    src="https://readdy.ai/api/search-image?query=Dynamic%20mahjong%20tile%20arrangement%20with%20warm%20golden%20lighting%2C%20modern%20Chinese%20aesthetic%2C%20elegant%20composition%2C%20textured%20wooden%20surface%2C%20refined%20color%20palette%20with%20burgundy%20and%20gold%20tones%2C%20editorial%20photography&width=800&height=400&seq=article-6&orientation=landscape"
                    alt={article.title}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                )}
                <div className="absolute top-3 left-3">
                  <span className="text-xs px-2.5 py-1 bg-background-50/90 backdrop-blur-sm text-foreground-700 rounded-full font-medium">
                    {article.category}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-base font-heading font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2 mb-3">
                  {article.excerpt}
                </p>
                <div className="flex items-center gap-3 text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-user-line"></i>
                    {article.author}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {article.readTime}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-calendar-line"></i>
                    {article.publishDate}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}